import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=2897844c&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports